import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

const { INPUT, COMBO_BOX, DATE, NUMBER, AUTO_COMPLETE } = FIELD_TYPE;

export const PPVoCam = [
  { value: "1", label: "Gây mê" },
  { value: "7", label: "Nhỏ tê tại chỗ" },
  { value: "2", label: "Tê cạnh nhãn cầu" },
  { value: "3", label: "Tê hậu nhãn cầu" },
  { value: "4", label: "Tê subtenon" },
  { value: "5", label: "Tê dưới da" },
  { value: "6", label: "Tiêm tê tại chỗ" },
  { value: "8", label: "Gây tê tại chỗ" },
];

const cssProps = {
  css: { xl: 24, md: 24 },
  labelCol: { xl: 4, md: 6 },
  wrapperCol: { xl: 20, md: 18 },
};

const fields: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Chẩn đoán trước phẫu thuật",
    css: { xl: 14, md: 14, sm: 24 },
    labelCol: { xl: 7, md: 10 },
    wrapperCol: { xl: 17, md: 14 },
    name: "chanDoanTruocPTList",
  },
  {
    type: COMBO_BOX,
    label: "",
    css: { xl: 10, md: 10, sm: 24 },
    wrapperCol: { xl: 24, md: 24 },
    name: "chanDoanTruocPTValue",
  },
  {
    type: COMBO_BOX,
    label: "Chẩn đoán sau phẫu thuật",
    css: { xl: 14, md: 14, sm: 24 },
    labelCol: { xl: 7, md: 10 },
    wrapperCol: { xl: 17, md: 14 },
    name: "chuanDoanSauPTList",
  },

  {
    type: COMBO_BOX,
    label: "",
    css: { xl: 10, md: 10, sm: 24 },
    wrapperCol: { xl: 24, md: 24 },
    name: "chuanDoanSauPTValue",
  },
  {
    type: COMBO_BOX,
    label: "Loại phẫu thuật/ thủ thuật",
    ...cssProps,
    name: "loaiPhauThuatThuThuat",
    options: [
      {
        label: "Đặc biệt",
        value: "Đặc biệt",
      },
      {
        label: "Loại I",
        value: "Loại I",
      },
      {
        label: "Loại II",
        value: "Loại II",
      },
      {
        label: "Loại III",
        value: "Loại III",
      },
      {
        label: "Loại IV",
        value: "Loại IV",
      },
    ],
  },
  {
    type: COMBO_BOX,
    label: "Phương pháp phẫu thuật",
    ...cssProps,
    name: "ppPhauThuat",
  },
  {
    type: INPUT,
    label: "Phương pháp thực tế",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    name: "ppThucTe",
  },
  {
    type: COMBO_BOX,
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    label: "Phương pháp vô cảm",
    name: "ppVoCam",
    options: PPVoCam,
  },
  {
    type: COMBO_BOX,
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    label: "Loại thủy tinh thể nhân tạo",
    name: "ttNhanTao",
  },
  {
    type: INPUT,
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    label: "Công suất TTT nhân tạo",
    name: "congSuatTTTNhanTao",
  },
  {
    type: DATE,
    name: "thoiGianBatDau",
    css: { xl: 12, lg: 12, md: 24 },
    labelCol: { xl: 8, lg: 12, md: 6 },
    wrapperCol: { xl: 16, lg: 12, md: 18 },
    label: "Thời gian bắt đầu",
    optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
    changeOnBlur: true,
    disableDate: false,
  },
  {
    type: DATE,
    name: "thoiGianKetThuc",
    css: { xl: 12, lg: 12, md: 24 },
    labelCol: { xl: 8, lg: 12, md: 6 },
    wrapperCol: { xl: 16, lg: 12, md: 18 },
    label: "Thời gian kết thúc",
    optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
    changeOnBlur: true,
    disableDate: false,

  },
];

export { fields };
